import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class EscolaridadService 
{
    constructor(private http: HttpClient) { }

    traePostulantes(rut: any)
    {
        return this.http.get(`${environment.urlBase}/afiliados/rut/${rut}`, 
               { headers: this.armaCabecera() }).toPromise();
    }

    ingresaEscolaridad(escolaridad: any, idUsuario: any, idCarga: any, nombreUsuario: any,idUsuarioSesion: any)
    {
        console.log(idUsuario, idCarga);
        return this.http.post(`${environment.urlBase}/postulaciones/escolaridad`, 
        {
            idUsuario: idUsuario,
            idCarga:idCarga,
            idProducto: 2,
            email: escolaridad.email,
            idUsuarioSesion:idUsuarioSesion,
            escolaridad: { fechaCertificado:escolaridad.fechaCertificado, etapa: escolaridad.etapaEscolar },
            archivoAdjunto: [ { url: "", archivo: escolaridad.archivo.bytes, extension:escolaridad.archivo.tipo } ],
            //archivoAdjunto: [ { url: "nada" } ],
            notificacion: { email:escolaridad.email, nombreCompleto:nombreUsuario, nombreProducto: 'ESCOLARIDAD' }

        }, { headers: this.armaCabecera() }).toPromise();
    }

    armaCabecera()
    {
        return new HttpHeaders({            
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        });
    }
}